define('CustomPDPLink.View', [
    '_custompdplink.tpl',
    'SCView'
], function customMessagePDP(
    template,
    SCViewComponent
) {
    'use strict';

    var SCView = SCViewComponent.SCView;

    function CustomPDPMessageView(options) {
        SCView.call(this);
        this.contextDataRequest = ['item'];
        this.options = options;
        this.template = template;
    }

    CustomPDPMessageView.prototype = Object.create(SCView.prototype);
    CustomPDPMessageView.prototype.constructor = SCView;
    CustomPDPMessageView.prototype.getEvents = function getEvents() {
        return {
        };
    };

    CustomPDPMessageView.prototype.getContext = function getContext() {
        var image = this.contextData.item().custitem_affiliate_link_img	;
        var url = this.contextData.item().custitem_affiliate_link_url	;
        return {
            hasImage: image,
            hasUrl: url
        };
    };

    return CustomPDPMessageView;
});
